import { createContext } from "react";

const createQuesContext = createContext({});

export default createQuesContext;
